import styles from './BoardColumn.module.scss';

import { ColumnFiltersState, GroupingState } from '@tanstack/react-table';

import { Filters } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';
import { ICustomCellConfigBase } from '@work4all/models/lib/table-schema/table-schema';

import { IUseEntityDataOptions } from '../../../entity-table/use-entity-data-table';

import { BoardColumn } from './BoardColumn';

export interface BoardProps
  extends IUseEntityDataOptions<
    unknown,
    Record<string, ICustomCellConfigBase>
  > {
  columns: {
    key: string;
    status: string;
    prefilter: Filters;
  }[];
  onDrop: (item: unknown, key: string) => void;
  grouping: GroupingState;
  columnFilters: ColumnFiltersState;
}

export const Board = (props: BoardProps) => {
  const { columns, onDrop, columnFilters, grouping, ...tableProps } = props;

  return (
    <div className={styles.wrapper}>
      {columns.map(({ key, status, prefilter }) => (
        <BoardColumn
          key={status}
          status={status}
          prefilter={prefilter}
          columnFilters={columnFilters}
          grouping={grouping}
          onDrop={(item) => onDrop(item, key)}
          tableProps={tableProps}
        />
      ))}
    </div>
  );
};

const BOARD_ENABLED_ENTITIES = [Entities.task, Entities.ticket];
export const isBoardEnabled = (entityType: Entities) =>
  BOARD_ENABLED_ENTITIES.includes(entityType);

const CARD_DISABLED_ENTITIES = [
  Entities.position,
  Entities.positionDetails,
  Entities.timeTracking,
];

export const isCardEnabled = (entityType: Entities) => {
  return !CARD_DISABLED_ENTITIES.includes(entityType);
};
